export const ORDER = ["Salons and barbers", "Electronics assembly and soldering", "Greenhouses and nurseries", "Field farming and harvesting", "Farm packing houses", "Commercial kitchens", "Brewpubs and restaurants", "Bakeries", "Caf\u00e9s and beverage counters", "Bars and lounges", "Butchery", "Restaurant service", "Garment manufacturing", "Tailoring", "Commercial and office cleaning", "Laundries", "Dish and crate washing", "Packaging and co-packing", "Printing and signage", "Metal fabrication", "Tool and die workshops", "Manufacturing and assembly", "Automotive parts assembly", "Laboratories", "Painting and finishing", "Plumbing", "Electrical work", "Construction and building", "Transport and delivery", "Bike and small-engine repair", "Auto repair and tyre shops", "Jewellery workshops", "Clinics and diagnostic centres", "Hotel housekeeping", "Book and stationery shelving", "Offices and meeting rooms", "Specialty retail", "Warehouse picking and packing", "Sortation and dispatch"];

export const KEYS = ["env", "task", "obj"];

const split = (s) => (s || "").split(";").map((x) => x.trim().toLowerCase()).filter(Boolean);

export const TASK = (r) => r.specific_task || r.task.toLowerCase();
export const ENV = (r) => r.specific_environment || r.environment;
export const KEY = { task: (r) => [TASK(r)], env: (r) => [ENV(r)], obj: (r) => r._objs };

export const prepareRows = (rows) =>
  rows.map((r) => {
    const _objs = [...new Set([...split(r.objects), ...split(r.tools)])];
    const _hay = [r.objects, r.tools, r.action, r.activities, r.caption, r.workflow_step, r.environment_raw, r.task, r.category,
      r.specific_environment, r.industry, r.sub_industry, r.specific_task].join(" ").toLowerCase();
    return { ...r, _objs, _hay };
  });

export const thumbSrc = (r) => `/gallery/thumb/${r.id}.webp`;
export const fullSrc = (r) => `/gallery/full/${r.id}.jpg`;

export const emptyFilters = () => ({ env: new Set(), task: new Set(), obj: new Set(), q: "" });

export const readHash = () => {
  const p = new URLSearchParams(window.location.hash.slice(1));
  const f = emptyFilters();
  f.q = p.get("q") || "";
  KEYS.forEach((k) => { f[k] = new Set(p.getAll(k)); });
  return f;
};

export const writeHash = (f) => {
  const p = new URLSearchParams();
  if (f.q) p.set("q", f.q);
  KEYS.forEach((k) => f[k].forEach((v) => p.append(k, v)));
  const s = p.toString();
  window.history.replaceState(null, "", s ? "#" + s : window.location.pathname);
};

export const matches = (r, f, skip) => {
  for (const k of KEYS) {
    if (k === skip || !f[k].size) continue;
    if (!KEY[k](r).some((v) => f[k].has(v))) return false;
  }
  if (f.q && !f.q.toLowerCase().split(/\s+/).every((w) => r._hay.includes(w))) return false;
  return true;
};

export const chipCounts = (rows, f, k, limit) => {
  const n = new Map();
  rows.filter((r) => matches(r, f, k)).forEach((r) => KEY[k](r).forEach((v) => n.set(v, (n.get(v) || 0) + 1)));
  f[k].forEach((v) => n.has(v) || n.set(v, 0));
  return [...n].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0])).slice(0, limit);
};

export const uniqCount = (rows, fn) => new Set(rows.flatMap(fn)).size;

export const groupByCategory = (rows) => {
  const m = new Map();
  rows.forEach((r) => (m.get(r.category) || m.set(r.category, []).get(r.category)).push(r));
  return [...m].sort((a, b) => ORDER.indexOf(a[0]) - ORDER.indexOf(b[0]));
};
